/* eslint-disable no-new */
import JudgmentSlider from './modules/JudgmentSlider';
import ScrollButton from './modules/ScrollButton';
import Navigation from './modules/Navigation';
import JokeSlider from './modules/JokeSlider';
import DetailsElement from './modules/DetailsElement';
import ContactForm from './modules/ContactForm';
import LeafletMap from './modules/LeafletMap';
import 'details-element-polyfill';
import 'mdn-polyfills/NodeList.prototype.forEach';
import 'mdn-polyfills/Element.prototype.closest';
import 'svg-classlist-polyfill';
import 'svgxuse';
// eslint-disable-next-line

new JudgmentSlider();
new JokeSlider();
new ScrollButton();
new Navigation();
new DetailsElement();
new ContactForm();
new LeafletMap();

// eslint-disable-next-line
import style from '../scss/dark-theme.scss';
